import assetPath from '/opt/actions-runner/_work/crate/crate/packages/master-directory/head/src/assets/og-xing-logo.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')